import { APICall } from "@/config/NetworkUtility";

const logImportApiError = (label, error, payload) => {
    console.error(`❌ ${label} failed`, {
        url: error?.config?.url,
        method: error?.config?.method,
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        responseData: error?.response?.data,
        message: error?.message,
        payload,
    });
};

export const getModuleDetails = (moduleType = "ALL") => {
    return dispatch => {
        const url = `v2/CompanySetup/GetModuleDetails?ModuleType=${moduleType}`;

        return APICall("get", null, url).then(
            result => {
                if (
                    result?.statuscode === 200 ||
                    result?.statuscode === 201
                ) {
                    return result?.data || [];
                } else {
                    return Promise.reject(result);
                }
            },
            error => {
                return Promise.reject(error);
            }
        );
    };
};

// ======================================
// GET  MODULES DROPDOWN
// ======================================


export const getModuleDropdown = (id) => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const url = `v1/ModuleSetup/GetModuleDropdownList?BASEMODULE_ID=${id}`;

    const result = await APICall("get", null, url);

    if (result?.statuscode === 200 || result?.statuscode === 201) {
      return result?.data || [];
    }

    return Promise.reject(result);
  } catch (error) {
    logApiError(error, {
      source: "getModuleDropdownList",
      endpoint: "GetModuleDropdownList",
    });

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};